var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3741 24.4962L4.03336 16.0845C3.10396 15.1472 1.62645 15.1472 0.697051 16.0845C-0.23235 17.0218 -0.23235 18.5119 0.697051 19.4492L10.6822 29.5192C11.6116 30.4565 13.1129 30.4565 14.0423 29.5192L39.3029 4.06768C40.2323 3.13037 40.2323 1.64029 39.3029 0.702982C38.3735 -0.234327 36.896 -0.234327 35.9666 0.702982L12.3741 24.4962Z",
    fill: "#C1D659"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkIcon.ec454afc.svg";
export { ForwardRef as ReactComponent };